import type { MallCategory } from '@/constants/mallProducts'

/** 상품 등록 폼에서 고를 수 있는 카테고리 */
export const SELLER_CATEGORIES: MallCategory[] = ['위생용품', '의료/요양', '식품/건강', '생활용품']

/** 재고가 이 수량 이하면 보충이 필요하다고 본다 */
export const LOW_STOCK_THRESHOLD = 30

export type SellerOrderStatus =
  | 'paid'
  | 'ready'
  | 'shipping'
  | 'delivered'
  | 'cancelRequest'
  | 'cancelled'
  | 'returnRequest'

export const SELLER_ORDER_STATUS_LABEL: Record<SellerOrderStatus, string> = {
  paid: '결제완료',
  ready: '배송준비',
  shipping: '배송중',
  delivered: '배송완료',
  cancelRequest: '취소요청',
  cancelled: '취소완료',
  returnRequest: '반품요청',
}

/** 상태 배지 색 (sui-badge 변형) */
export const SELLER_ORDER_STATUS_TONE: Record<SellerOrderStatus, string> = {
  paid: 'sui-badge--blue',
  ready: 'sui-badge--blue',
  shipping: 'sui-badge--violet',
  delivered: 'sui-badge--green',
  cancelRequest: 'sui-badge--amber',
  cancelled: 'sui-badge--gray',
  returnRequest: 'sui-badge--amber',
}

/** 차트용 상태 색 */
export const SELLER_ORDER_STATUS_COLOR: Record<SellerOrderStatus, string> = {
  paid: '#1a5fa8',
  ready: '#3b82f6',
  shipping: '#0ea5a4',
  delivered: '#22a06b',
  cancelRequest: '#ec6a1a',
  returnRequest: '#c2410c',
  cancelled: '#98a2b3',
}

/** 목록 탭 순서 */
export const SELLER_ORDER_STATUS_FLOW: SellerOrderStatus[] = [
  'paid',
  'ready',
  'shipping',
  'delivered',
  'cancelRequest',
  'returnRequest',
  'cancelled',
]

/** 금액·수량을 천 단위 콤마로만 포맷한다. 단위(원·건 등)는 호출부에서 붙인다. */
export function formatWon(value: number): string {
  return Math.round(Number(value) || 0).toLocaleString('ko-KR')
}

export function compactWon(value: number): string {
  if (value >= 100_000_000) return `${(value / 100_000_000).toFixed(1)}억`
  if (value >= 10_000) return `${Math.round(value / 10_000)}만`
  return formatWon(value)
}
